module.exports = __webpack_public_path__ + "static/media/zoleLose_2500_5000.d951ee22.png";